/* eslint-disable semi */
/* eslint-disable comma-dangle */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Fragment } from 'react'
import { Slide, toast } from 'react-toastify'

import baseurl from '../../../@core/auth/jwt/baseurl'
import emiter from '../../../utility/hooks/emiiter'
const INITIAL_OBJECT = {
  approvanceDate: '',
  description: '',
  approvanceNumber: 0,
  prefix: null,
  approvedBy: '',
  status: null,
  uploads: [],
  decisions: [],
  newDecisions: [],
  committeeSession: null,
  committeeSessionId: null,
  id: null
}

const showErrorMsg = (error) => {
  toast.error(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Error</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{error}</span>
      </div>
    </Fragment>,
    {
      icon: false,
      transition: Slide,
      hideProgressBar: false,
      autoClose: 1500,
      position: toast.POSITION.TOP_CENTER
    }
  )
}

const showSuccessMsg = (msg) => {
  toast.success(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Success</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{msg}</span>
      </div>
    </Fragment>,
    {
      icon: false,
      transition: Slide,
      hideProgressBar: false,
      autoClose: 1500,
      position: toast.POSITION.TOP_CENTER
    }
  )
}

export const getData = createAsyncThunk(
  'appApprovance/getData',
  async (params) => {
    const response = await baseurl.get('/api/app/approvance', {
      params
    })
    return {
      params,
      data: response.data.items,
      total: response.data.totalCount
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const getById = createAsyncThunk(
  'appApprovance/getById',
  async (id) => {
    try {
      const response = await baseurl.get(`/api/app/approvance/${id}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (response.status === 200) {
        return response.data
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return rejectWithValue(response.data)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
  {
    dispatchConditionRejection: true
  }
)

export const addApprovance = createAsyncThunk(
  'appApprovance/addApprovance',
  async (approvance, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.post('/api/app/approvance', approvance, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        showSuccessMsg('Added Successfully')
        await dispatch(getData(getState().approvance.params))
        await dispatch(getById(res.data.id))
        return approvance
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
export const createCaseDecision = createAsyncThunk(
  'appApprovance/createCaseDecision',
  async (decision, { dispatch, rejectWithValue }) => {
    try {
      const res = await baseurl.post('/api/app/approvance/decision', decision, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        showSuccessMsg('Decision Create Successfully')
        await dispatch(getById(decision?.sessionId))
        return res.data
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
        return rejectWithValue(null)
      }
      return rejectWithValue(null)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updateCaseDecision = createAsyncThunk(
  'appApprovance/updateCaseDecision',
  async (decision, { rejectWithValue, dispatch }) => {
    try {
      const res = await baseurl.put(`/api/app/approvance/${decision.id}/decision`, decision, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        showSuccessMsg('Updated Successfully')
        await dispatch(getById(decision?.sessionId))

        return decision
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return rejectWithValue(null)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updateApprovance = createAsyncThunk(
  'appApprovance/updateApprovance',
  async (approvance, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.put(`/api/app/approvance/${approvance.id}`, approvance, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 200) {
        showSuccessMsg('Updated Successfully')
        await dispatch(getData(getState().approvance.params))
        await dispatch(getById(approvance.id))
        return approvance
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const deleteApprovance = createAsyncThunk(
  'appApprovance/deleteApprovance',
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await baseurl.delete(`/api/app/approvance/${id}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 204) {
        emiter.emit('close-approvance-delete-popup')
        await dispatch(getData(getState().approvance.params))
        return id
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const deleteDecision = createAsyncThunk(
  'appApprovance/deleteDecision',
  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const res = await baseurl.delete(`/api/app/approvance/${id}/decision`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (res.status === 204) {
        await dispatch(getById(getState().selectedApprovance?.id))

        return id
      } else if (res.status === 403) {
        showErrorMsg(res.data.error.message)
      }
      return rejectWithValue(error)
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const initApprovance = createAsyncThunk(
  'appApprovance/initApprovance',
  async () => {
    return []
  },
  {}
)

export const getComments = createAsyncThunk('appApprovance/getComments', async (id, { rejectWithValue }) => {
  try {
    const response = await baseurl.get(`/api/app/approvance/comments/${id}`, {
      validateStatus: (status) => {
        return status >= 200 && status <= 500
      }
    })
    if (response.status === 200) {
      return {
        comments: response.data
      }
    } else return rejectWithValue('')
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getDecisionTypeLookups = createAsyncThunk(
  'appApprovance/getDecisionTypeLookups',
  async (caseTypeId, { rejectWithValue }) => {
    if (caseTypeId === undefined) return rejectWithValue(null)
    try {
      const response = await baseurl.get(`/api/app/decision-type/lookup/${caseTypeId}`, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        }
      })
      if (response.status === 200) {
        return response.data
      } else return rejectWithValue('')
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const addComment = createAsyncThunk(
  'appApprovance/addComment',
  async ({ comment, callback }, { rejectWithValue }) => {
    try {
      const response = await baseurl.post(`/api/app/approvance/comment`, comment, {
        validateStatus: (status) => {
          return status >= 200 && status <= 500
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          accept: 'text/plain'
        }
      })
      if (response.status === 200) {
        // dispatch(getLogs(getState().createCase?.mainCase?.id))
        callback()
        return response.data
      } else return rejectWithValue('')
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const appApprovanceSlice = createSlice({
  name: 'appApprovance',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedApprovance: null,
    loading: true,
    getByIdLoading: false,
    initLoading: false,
    saveLoading: false,
    decisionSessionCase: null,
    saveDecisionLoading: false
  },
  reducers: {
    setUploads: (state, action) => {
      state.selectedApprovance = {
        ...state.selectedApprovance,
        uploads: action.payload
      }
    },
    setDecisionSessionCase: (state, action) => {
      state.decisionSessionCase = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.rejected, (state) => {
        state.loading = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.total
        state.loading = false
      })

      .addCase(getById.pending, (state) => {
        state.getByIdLoading = true
        state.selectedApprovance = null
      })
      .addCase(getById.rejected, (state) => {
        state.getByIdLoading = false
      })
      .addCase(getById.fulfilled, (state, action) => {
        state.getByIdLoading = false
        state.selectedApprovance = action.payload
      })

      .addCase(addApprovance.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(addApprovance.rejected, (state) => {
        state.saveLoading = false
      })
      .addCase(addApprovance.fulfilled, (state) => {
        state.saveLoading = false
      })

      .addCase(createCaseDecision.pending, (state) => {
        state.saveDecisionLoading = true
      })
      .addCase(createCaseDecision.rejected, (state) => {
        state.saveDecisionLoading = false
      })
      .addCase(createCaseDecision.fulfilled, (state, action) => {
        state.saveDecisionLoading = false
        state.decisionSessionCase = {
          ...state.decisionSessionCase,
          decision: action.payload
        }
      })

      .addCase(updateCaseDecision.pending, (state) => {
        state.saveDecisionLoading = true
      })
      .addCase(updateCaseDecision.rejected, (state) => {
        state.saveDecisionLoading = false
      })
      .addCase(updateCaseDecision.fulfilled, (state, action) => {
        state.saveDecisionLoading = false
        state.decisionSessionCase = {
          ...state.decisionSessionCase,
          decision: action.payload
        }
      })

      .addCase(updateApprovance.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(updateApprovance.rejected, (state) => {
        state.saveLoading = false
      })
      .addCase(updateApprovance.fulfilled, (state) => {
        state.saveLoading = false
      })

      .addCase(deleteApprovance.pending, (state) => {
        state.deleteLoading = true
      })
      .addCase(deleteApprovance.rejected, (state) => {
        state.deleteLoading = false
      })
      .addCase(deleteApprovance.fulfilled, (state) => {
        state.deleteLoading = false
      })

      .addCase(deleteDecision.pending, (state) => {
        state.saveDecisionLoading = true
      })
      .addCase(deleteDecision.rejected, (state) => {
        state.saveDecisionLoading = false
      })
      .addCase(deleteDecision.fulfilled, (state) => {
        state.saveDecisionLoading = false
        state.decisionSessionCase = {
          ...state.decisionSessionCase,
          decision: null
        }
      })

      .addCase(initApprovance.pending, (state) => {
        state.initLoading = true
      })
      .addCase(initApprovance.rejected, (state) => {
        state.initLoading = false
      })
      .addCase(initApprovance.fulfilled, (state) => {
        state.selectedApprovance = {
          ...INITIAL_OBJECT,
          id: null,
          decisions: [],
          newDecisions: []
        }
        state.initLoading = false
      })

    builder.addCase(getComments.pending, (state) => {
      state.comments = []
      state.commentsLoading = true
    })

    builder.addCase(getComments.rejected, (state) => {
      state.comments = []
      state.commentsLoading = false
    })
    builder.addCase(getComments.fulfilled, (state, action) => {
      state.comments = action.payload.comments
      state.commentsLoading = false
    })

    builder.addCase(addComment.pending, (state) => {
      state.addCommentLoading = true
    })

    builder.addCase(addComment.rejected, (state) => {
      state.addCommentLoading = false
    })

    builder.addCase(addComment.fulfilled, (state, action) => {
      state.addCommentLoading = false
      // prepend new comment to the list
      state.comments = [action.payload, ...state.comments]
    })

    builder.addCase(getDecisionTypeLookups.pending, (state) => {
      state.decisionTypes = []
    })

    builder.addCase(getDecisionTypeLookups.rejected, (state) => {
      state.decisionTypes = []
    })

    builder.addCase(getDecisionTypeLookups.fulfilled, (state, action) => {
      state.decisionTypes = action.payload
    })
  }
})
export const { setUploads, setDecisionSessionCase } = appApprovanceSlice.actions
export default appApprovanceSlice.reducer
